import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useLazyCheckPincodeQuery } from "slices/common/locationSlice";

// Props: open (boolean), onClose (function), onResult (function)
function PincodeChecker({ open, onClose, onResult, city }) {
  const [pincode, setPincode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ✅ RTK Query lazy hook
  const [checkPincode, { data, isFetching, isError }] =
    useLazyCheckPincodeQuery();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pincode) {
      setError("Pincode is required");
      return;
    }
    setError("");

    try {
      // trigger API call
      await checkPincode({ city, pincode }).unwrap();
    } catch (err) {
      console.error("RTK Query error:", err);
      setError("Failed to fetch pincode details.");
    }
  };

  useEffect(() => {
    if (data) {
      onResult(data);
      onClose();
      setPincode("");
    }
  }, [data]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Check Pincode</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Enter Pincode"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            fullWidth
            margin="normal"
            error={Boolean(error)}
            helperText={error}
          />
          <DialogActions>
            <Button onClick={onClose} color="secondary">
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Submit"}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default PincodeChecker;
